<template>
  <div class="admin flexB">
    <Lnb />
    <router-view></router-view>
  </div>
</template>
<script>
import Lnb from "@/components/Lnb";

export default {
  components: { Lnb },
};
</script>
